import { useEffect, useState } from "react";
import PropTypes from "prop-types";

import Icon from "@mui/material/Icon";
import Switch from "@mui/material/Switch";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { useMaterialUIController } from "context";
import {
  DASHBOARD_CARD_SETTINGS,
  getStoredDashboardCardVisibility,
  normalizeDashboardCardVisibility,
  persistDashboardCardVisibility,
  subscribeToDashboardCardVisibility,
} from "utils/dashboardCardVisibility";

function DashboardCardVisibilitySettings({ title }) {
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;
  const [dashboardCardVisibility, setDashboardCardVisibility] = useState(
    getStoredDashboardCardVisibility
  );

  useEffect(
    () => subscribeToDashboardCardVisibility(setDashboardCardVisibility),
    []
  );

  const handleDashboardCardVisibility = (cardKey) => {
    setDashboardCardVisibility((currentVisibility) => {
      const nextVisibility = normalizeDashboardCardVisibility({
        ...currentVisibility,
        [cardKey]: currentVisibility[cardKey] === false,
      });

      return persistDashboardCardVisibility(nextVisibility);
    });
  };

  return (
    <MDBox lineHeight={1}>
      {title && (
        <MDTypography variant="h6" fontWeight="medium">
          {title}
        </MDTypography>
      )}
      <MDBox mt={1}>
        {DASHBOARD_CARD_SETTINGS.map((setting) => (
          <MDBox
            key={setting.key}
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            gap={1.5}
            py={0.75}
          >
            <MDBox display="flex" alignItems="center" gap={1} sx={{ minWidth: 0 }}>
              <Icon
                fontSize="small"
                sx={({ palette: { text, white }, functions: { rgba } }) => ({
                  color: darkMode ? rgba(white.main, 0.8) : text.main,
                  flexShrink: 0,
                })}
              >
                {setting.icon}
              </Icon>
              <MDTypography
                variant="button"
                fontWeight="regular"
                color="text"
                sx={{
                  minWidth: 0,
                  lineHeight: 1.25,
                  overflowWrap: "anywhere",
                }}
              >
                {setting.label}
              </MDTypography>
            </MDBox>
            <Switch
              checked={dashboardCardVisibility[setting.key] !== false}
              onChange={() => handleDashboardCardVisibility(setting.key)}
            />
          </MDBox>
        ))}
      </MDBox>
    </MDBox>
  );
}

DashboardCardVisibilitySettings.defaultProps = {
  title: "Dashboard",
};

DashboardCardVisibilitySettings.propTypes = {
  title: PropTypes.string,
};

export default DashboardCardVisibilitySettings;
